import { NAMESPACE } from 'locale'
import { shiftPasswordsConstants } from 'locale/shiftPasswords'
import { Component } from 'react'
import { withTranslation } from 'react-i18next'
import ShiftPasswordForm from '../forms/popups/ShiftPasswordForm'
import Modal from '.'
import PopupModal from './PopupModal'

interface AddShiftModalProps {
  fetchList: (list: string) => void
  createItem: (data: any) => void
  showToast: (options: { title: string }) => void
  fields: any // Replace 'any' with a specific type if available
  isOpen: boolean
  t: (key: string) => string
}

export class AddShiftModal extends Component<AddShiftModalProps> {
  handleSubmit = () => {
    const { fetchList, createItem, showToast, t } = this.props
    createItem({
      url: 'list/shifts',
      onComplete: () => {
        showToast({ title: t(shiftPasswordsConstants.PASSWORD_ADDED) })
        fetchList('shifts')
      }
    })
  }

  render() {
    const { fields, isOpen, t, ...formProps } = this.props

    if (!isOpen) return null
    return (
      <PopupModal
        title={t(shiftPasswordsConstants.ADDING_NEW_PASSWORD)}
        confirmText="Add"
        buttonIcon="PlusOutlined"
        buttonColour="success"
        list="Shift"
        includesRequired
        onConfirm={this.handleSubmit}
        supportArticle={SUPPORT_ARTICLE}
        type="create"
        footerStyle={styles.footer}
        {...formProps}
      >
        <ShiftPasswordForm fields={fields} formId={MODAL_ID} />
      </PopupModal>
    )
  }
}

const MODAL_ID = 'addShift'
const SUPPORT_ARTICLE =
  'https://support.logmycare.co.uk/the-care-office/finishing-your-essential-setup/how-do-i-set-up-a-shift-password'

const styles = {
  footer: {
    justifyContent: 'space-between'
  }
}

export default Modal(
  withTranslation(NAMESPACE.SHIFT_PASSWORDS)(AddShiftModal),
  MODAL_ID
)
